export const SWIPE_THRESHOLD = 30;
export const INITIAL_TRANSLATE_X = '0';
export const TRANSLATE_X_REG_EXP = /translateX\(([^)]+)px\)/;
export const SLIDE_SELECTOR = '.yarl__slide_current .yarl__fullsize';
